module.exports = __webpack_public_path__ + "static/bgMobile.e392356e.png";